import { useEffect, useState } from 'react';
import { networkMonitor } from './networkUtils';
import { showNotification } from './notificationSystem';

export const useNetworkNotifications = () => {
  const [networkStatus, setNetworkStatus] = useState(networkMonitor.getStatus());
  const [previousNetworkStatus, setPreviousNetworkStatus] = useState(networkMonitor.getStatus());

  useEffect(() => {
    const unsubscribe = networkMonitor.subscribe(setNetworkStatus);
    return unsubscribe;
  }, []);

  useEffect(() => {
    const wasOffline = !previousNetworkStatus.isOnline;
    const isNowOnline = networkStatus.isOnline;
    const isNowOffline = !networkStatus.isOnline;

    if (isNowOffline) {
      showNotification("You appear to be offline. Connection will be re-established automatically.", "warning", 6000, { key: 'network-offline' });
      setPreviousNetworkStatus(networkStatus);
    } else if (isNowOnline && wasOffline) {
      showNotification("Connection restored.", "info", 3000, { key: 'network-online' });
      setPreviousNetworkStatus(networkStatus);
    } else if (isNowOnline && !wasOffline) {
      setPreviousNetworkStatus(networkStatus);
    }
  }, [networkStatus, previousNetworkStatus]);

  return { networkStatus, previousNetworkStatus, setPreviousNetworkStatus };
};